import { crudStatusEnum } from '../enums';

export const crudStatusEnumColors: Record<number, string> = {
    [crudStatusEnum.DELETED]: 'red',
    [crudStatusEnum.INACTIVE]: 'lightgrey',
    [crudStatusEnum.OK]: 'rgb(105, 144, 115)',
};

export const getCrudStatusColor = (state?: number): string => {
    return state !== undefined ? (crudStatusEnumColors[state] ?? '') : '';
};
